import { Fragment, useEffect, useState } from "react";
import HeaderSection from "../header/header.component";
import { Col, Modal, Row } from "react-bootstrap";
import {
  errorRed,
  netural400,
  neturalBlack,
  success700,
} from "../../constants/color";
import { useNavigate, useParams } from "react-router-dom";
import CustomLabel from "../shared/label/custom-label.component";
import CustomButton from "../button/button.component";
import UpdateOrderStatus from "../update-order-status-section/update-order-status-section.component";
import { FETCH_REPORT_DETAILS } from "../../services/graphql/report";
import { useLazyQuery, useMutation } from "@apollo/client";
import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";
import GlobalModal from "../modal-popup/global-modal";
import { UPDATE_ORDER_STATUS } from "../../services/graphql/sales";
import { PLATFORM_EMAILS, STATUS_LABELS } from "../../constants/constant";
import { useSelector } from "react-redux";

const ReportDetails = () => {
  const { reportId } = useParams();
  const navigation = useNavigate();
  const businesprofile = useSelector((state) => state.businesprofile);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [reportInfo, setReportInfo] = useState({});
  const [reportSummary, setReportSummary] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [reportDetails, setReportDetails] = useState({});
  const [orderData, setOrderData] = useState({
    orderStatusList: [
      { value: "in_progress", label: "In progress" },
      { value: "resolved", label: "Resolved" },
    ],
  });
  const [orderStatus, setOrderStatus] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    if (reportId) {
      fetchReportDetails({
        variables: {
          reportId: reportId,
        },
      });
    }
  }, [reportId]);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const handleStatusChange = (e) => {
    setOrderStatus(e.target.value);
  };

  const [fetchReportDetails, { loading: loadingFetchReportDetails }] =
    useLazyQuery(FETCH_REPORT_DETAILS, {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        if (data && data.fetchReportDetails) {
          const responseOrder = data.fetchReportDetails;
          if (responseOrder.success) {
            // console.log(
            //   "Fetch value---------",
            //   responseOrder.report.reportSummary
            // );
            setReportInfo(responseOrder.report);
            setReportSummary(responseOrder.report.reportSummary);
            setUserInfo(responseOrder.report.userInfo);
            setReportDetails(responseOrder.report.reportDetails);
            setOrderStatus(responseOrder.report.reportDetails.status);
            const reportDetails = responseOrder.report.reportDetails;
            setOrderData({
              ...orderData,
              status: reportDetails.status,
            });
          } else {
            alert("Something went wrong, please try again later!");
          }
        }
      },
      onError(error) {
        alert("Something went wrong, please try again later!" + error);
      },
    });
  const [updateOrderStatus, { loading: loadingUpdateOrderStatus }] =
    useMutation(UPDATE_ORDER_STATUS, {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        if (data && data.updateOrderStatus) {
          const responseOrder = data.updateOrderStatus;
          if (responseOrder.success) {
            setShowConfirmModal(false);
            setReportSummary(responseOrder.report.reportSummary);
            setUserInfo(responseOrder.report.userInfo);
            setReportDetails(responseOrder.report.reportDetails);
            setOrderStatus(responseOrder.report.reportDetails.status);

            const reportDetails = responseOrder.report.reportDetails;
            setOrderData({
              ...orderData,
              status: reportDetails.status,
            });
          } else {
            alert(
              responseOrder.message ||
                "Something went wrong, please try again later!"
            );
          }
        }
      },
      onError(error) {
        alert(error.message || "Something went wrong, please try again later!");
      },
    });

  const handleConfirmClick = async () => {
    const updateOrderStatusInput = {
      orderId: reportDetails.orderId,
      newStatus: orderStatus,
    };
    if (reportInfo.orderType === "autoship") {
      updateOrderStatusInput.isAutoship = true;
      updateOrderStatusInput.subscriptionId = reportInfo.productSubscriptionId;
    }
    await updateOrderStatus({
      variables: {
        updateOrderStatusInput,
      },
    });
  };

  return (
    <div
      className="main-div-right-section"
      style={{ backgroundColor: "white" }}
    >
      {loadingFetchReportDetails || loadingUpdateOrderStatus ? (
        <LoadingSpinner overlay={false} />
      ) : (
        <>
          <Fragment>
            <HeaderSection currentTab={"Report"} />
            <div className="second-section-style">
              <Fragment>
                <Row>
                  <Col
                    lg="8"
                    md="8"
                    sm="8"
                    xs="8"
                    style={{
                      paddingLeft: "0px",
                      display: "flex",
                      marginTop: "2%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: neturalBlack,
                        }}
                      >
                        Order ID #{reportId}
                      </label>
                    </div>
                    <div style={{ marginTop: "3%" }}>
                      <CustomLabel
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: neturalBlack,
                        }}
                      >
                        Report summary
                      </CustomLabel>
                    </div>
                    <div
                      style={{
                        border: "solid 1px #DADADA",
                        marginTop: "3%",
                      }}
                    ></div>
                    <div
                      style={{
                        marginTop: "3%",
                        marginRight: "10%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <CustomLabel
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: neturalBlack,
                        }}
                      >
                        The issue:
                      </CustomLabel>
                      <CustomLabel
                        style={{
                          fontSize: "16px",
                          fontWeight: "normal",
                          color: netural400,
                          marginTop: "2%",
                        }}
                      >
                        {reportSummary.description}
                      </CustomLabel>
                      {/* {reportSummary.medias.length > 0 && (
                        <> */}
                      <CustomLabel
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: neturalBlack,
                          marginTop: "3%",
                        }}
                      >
                        Attachments:
                      </CustomLabel>
                      {/* Image list */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          overflowX: "auto",
                          marginTop: "2%",
                          gap: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        {reportSummary.medias &&
                        reportSummary.medias.length > 0 ? (
                          reportSummary.medias.slice(0, 7).map((image) => (
                            <img
                              key={image._id}
                              src={`${process.env.REACT_APP_HOST_URL}${
                                image.mediaType === "video"
                                  ? "/" + image.uri_thumbnail
                                  : image.uri
                              }`}
                              alt={`Attachment ${image._id}`}
                              onClick={() => handleImageClick(image)}
                              style={{
                                width: "120px",
                                height: "100px",
                                objectFit: "contain",
                                border: "solid 1px #DADADA",
                                borderRadius: "12px",
                                flexShrink: 0, // Prevent image from shrinking
                              }}
                            />
                          ))
                        ) : (
                          <CustomLabel style={{ color: netural400 }}>
                            No attachments
                          </CustomLabel>
                        )}
                      </div>
                      {/* </>
                      )} */}
                    </div>
                    <div
                      style={{
                        border: "solid 1px #DADADA",
                        marginTop: "3%",
                      }}
                    ></div>
                    <UpdateOrderStatus
                      orderData={orderData}
                      showButton={true}
                      handleStatusChange={handleStatusChange}
                      orderStatus={orderStatus}
                      handleButtonClick={() => setShowConfirmModal(true)}
                      loadingUpdateOrderStatus={loadingUpdateOrderStatus}
                      sectionTitle="Status"
                      sectionDescription=""
                      containerStyle={{ width: "50%" }}
                    />
                    <div
                      style={{
                        border: "solid 1px #DADADA",
                        marginTop: "1%",
                      }}
                    ></div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "left",
                        gap: "16px",
                        marginTop: "2%",
                        flex: 1,
                      }}
                    >
                      <CustomButton
                        title="Reply to customer"
                        buttonType="validation"
                        handleButtonClick={() => {
                          const customerEmail = userInfo.email;
                          const ccEmail = PLATFORM_EMAILS.support;
                          const subject = encodeURIComponent(
                            `Response to Your Report - [Order ID ${reportDetails.orderId}]`
                          );
                          const body = encodeURIComponent(
                            `Hi ${userInfo.userName},\n\nThank you for your message. We are looking into it.\n\nAdd more infromation about it....\n\nBest regards,\n${businesprofile.name}\n${businesprofile.phone}`
                          );
                          const mailtoLink = `mailto:${customerEmail}?cc=${ccEmail}&subject=${subject}&body=${body}`;
                          window.location.href = mailtoLink;
                        }}
                        customStyle={{ marginTop: "12px", width: "40%" }}
                        isValid={
                          reportDetails.status === "in_progress" ? true : false
                        }
                      />
                      {reportDetails.status === "in_progress" && (
                        <CustomButton
                          title="Escalate report"
                          buttonType="secondary"
                          handleButtonClick={() => {
                            const customerEmail = userInfo.email;
                            const ccEmail = PLATFORM_EMAILS.support;
                            const subject = encodeURIComponent(
                              `Escalation Request - Report for Order ID: ${reportDetails.orderId}`
                            );
                            const emailBody = encodeURIComponent(
                              `Dear My Team,\n\nI am reaching out to escalate a report regarding Order ID: ${reportDetails.orderId}, initially submitted by ${userInfo.userName}. I would appreciate your assistance in reviewing the case and providing further guidance.\n\nSummary of the Issue:\n\t- Customer’s reported problem: ${reportSummary.description}\n\t- Actions taken so far: explain if is their any action taken\n\nI would appreciate your review of this case and any next steps you can recommend. Please let me know if you need any additional details.\n\nBest regards,\n${businesprofile.name}\n${businesprofile.phone}`
                            );
                            const mailtoLink = `mailto:${customerEmail}?cc=${ccEmail}&subject=${subject}&body=${emailBody}`;
                            window.location.href = mailtoLink;
                          }}
                          customStyle={{ marginTop: "12px", width: "40%" }}
                        />
                      )}
                    </div>
                  </Col>
                  <Col
                    lg="4"
                    md="4"
                    sm="4"
                    xs="4"
                    style={{
                      paddingLeft: "2%",
                      display: "flex",
                      paddingTop: "2%",
                      height: "90vh",
                      borderLeft: "solid 1px #DADADA",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: "white",
                        }}
                      >
                        #
                      </label>
                    </div>
                    <div style={{ marginTop: "5%", width: "100%" }}>
                      <CustomLabel
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: neturalBlack,
                        }}
                      >
                        Customer
                      </CustomLabel>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "5%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          Name
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color: neturalBlack,
                          }}
                        >
                          {userInfo.userName}
                        </CustomLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "2%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          Phone
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          {userInfo.phone}
                        </CustomLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "2%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          Email
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color: neturalBlack,
                          }}
                        >
                          {userInfo.email}
                        </CustomLabel>
                      </div>
                    </div>
                    <div
                      style={{
                        border: "solid 1px #DADADA",
                        marginTop: "8%",
                      }}
                    ></div>
                    <div style={{ marginTop: "8%", width: "100%" }}>
                      <CustomLabel
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: neturalBlack,
                        }}
                      >
                        Report details
                      </CustomLabel>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "5%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          Status
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color:
                              reportDetails.status === "in_progress"
                                ? errorRed
                                : success700,
                            backgroundColor:
                              reportDetails.status === "in_progress"
                                ? "#FDE7E7"
                                : "#E6F6E6",
                            borderRadius: "12px",
                            padding: "0.5% 1%",
                          }}
                        >
                          {STATUS_LABELS[reportDetails.status] ||
                            reportDetails.status}
                        </CustomLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "2%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          Reported on
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color: neturalBlack,
                          }}
                        >
                          {reportDetails.reportedOn}
                        </CustomLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "2%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          Reply by
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color: errorRed,
                          }}
                        >
                          {reportDetails.replyBy}
                        </CustomLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "2%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          {reportInfo.orderType === "Service"
                            ? "Booking"
                            : "Order"}{" "}
                          ID
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color: neturalBlack,
                          }}
                        >
                          #{reportDetails.orderId}
                        </CustomLabel>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginTop: "2%",
                        }}
                      >
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: neturalBlack,
                          }}
                        >
                          {reportInfo.orderType === "Service"
                            ? "Purchase"
                            : "Order"}{" "}
                          date
                        </CustomLabel>
                        <CustomLabel
                          style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            color: neturalBlack,
                          }}
                        >
                          {reportDetails.purchaseDate}
                        </CustomLabel>
                      </div>
                      {reportInfo.orderType === "Service" && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              marginTop: "2%",
                            }}
                          >
                            <CustomLabel
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: neturalBlack,
                              }}
                            >
                              Service method
                            </CustomLabel>
                            <CustomLabel
                              style={{
                                fontSize: "16px",
                                fontWeight: "normal",
                                color: neturalBlack,
                              }}
                            >
                              {reportDetails.serviceMethod}
                            </CustomLabel>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              marginTop: "2%",
                            }}
                          >
                            <CustomLabel
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: neturalBlack,
                              }}
                            >
                              Scheduled date
                            </CustomLabel>
                            <CustomLabel
                              style={{
                                fontSize: "16px",
                                fontWeight: "normal",
                                color: neturalBlack,
                              }}
                            >
                              {reportDetails.scheduleDate}
                            </CustomLabel>
                          </div>
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        borderTop: "solid 1px #DADADA",
                        marginTop: "8%",
                      }}
                    >
                      <CustomButton
                        title={
                          reportInfo.orderType === "Service"
                            ? "View service details"
                            : "View order details"
                        }
                        buttonType={"inverted"}
                        customStyle={{ marginTop: "8%" }}
                        handleButtonClick={() => {
                          //   Add type to redirect to product or service history page.
                          if (reportInfo.orderType === "Service") {
                            navigation(
                              `/sales/serviceDetail/${reportDetails.orderId}`
                            );
                          } else if (reportInfo.orderType === "Product") {
                            navigation(
                              `/sales/productDetail/${reportDetails.orderId}`
                            );
                          } else if (reportInfo.orderType === "autoship") {
                            navigation(
                              `/subscription/details/${reportInfo?.productSubscriptionId}`
                            );
                          }
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Fragment>
            </div>
          </Fragment>
          {/* Fullscreen Modal */}
          <Modal show={showModal} onHide={handleClose} centered size="lg">
            <Modal.Header
              closeButton
              style={{
                borderBottom: "0px solid rgb(0, 0, 0, 0.1)",
                paddingLeft: "3%",
                paddingRight: "3%",
                backgroundColor: "white",
                borderRadius: "12px",
              }}
            ></Modal.Header>
            <Modal.Body
              style={{
                backgroundColor: "black",
                padding: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedImage?.mediaType === "video" ? (
                <video
                  controls
                  autoPlay
                  style={{
                    maxWidth: "100%",
                    maxHeight: "90vh",
                    objectFit: "contain",
                  }}
                >
                  <source
                    src={`${process.env.REACT_APP_HOST_URL}${selectedImage?.uri}`}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={`${process.env.REACT_APP_HOST_URL}${selectedImage?.uri}`}
                  alt="Full Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "90vh",
                    objectFit: "contain",
                  }}
                />
              )}
            </Modal.Body>
          </Modal>
          {showConfirmModal && (
            <GlobalModal
              show={showConfirmModal}
              onClose={() => setShowConfirmModal(false)}
              showHeaderBorder={false}
              subtitle={
                "Are you sure you want to mark this report as resolved?"
              }
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  marginBottom: "1%",
                }}
              >
                Once confirmed:
              </p>
              <label
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  marginLeft: "2%",
                }}
              >
                • Action cannot be undone and the status cannot be changed
                anymore.
              </label>
              <label
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  marginLeft: "2%",
                }}
              >
                • We will notify the customer that the issue has been marked as
                resolved, informing them of the update on their report.
              </label>
              <CustomButton
                title={"Yes, Mark as resolved"}
                handleButtonClick={handleConfirmClick}
                customStyle={{ marginTop: "6%" }}
                loading={loadingUpdateOrderStatus}
              />
            </GlobalModal>
          )}
        </>
      )}
    </div>
  );
};

export default ReportDetails;
